export interface ChartColorTheme {
  id: string;
  name: string;
  colors: {
    upColor: string;
    downColor: string;
    wickUpColor: string;
    wickDownColor: string;
    borderUpColor: string;
    borderDownColor: string;
    volumeUpColor: string;
    volumeDownColor: string;
    longLineColor: string;
    shortLineColor: string;
  };
}

export const CHART_THEMES: ChartColorTheme[] = [
  {
    id: 'classic',
    name: 'Classic',
    colors: {
      upColor: '#37A16A',
      downColor: '#F71053',
      wickUpColor: '#37A16A',
      wickDownColor: '#F71053',
      borderUpColor: '#37A16A',
      borderDownColor: '#F71053',
      volumeUpColor: '#37A16A',
      volumeDownColor: '#F71053',
      longLineColor: '#37A16A',
      shortLineColor: '#F71053',
    },
  },
  {
    id: 'pro',
    name: 'Pro',
    colors: {
      upColor: '#26a69a',
      downColor: '#ef5350',
      wickUpColor: '#26a69a',
      wickDownColor: '#ef5350',
      borderUpColor: '#26a69a',
      borderDownColor: '#ef5350',
      volumeUpColor: '#26a69a',
      volumeDownColor: '#ef5350',
      longLineColor: '#26a69a',
      shortLineColor: '#ef5350',
    },
  },
  {
    id: 'modern',
    name: 'Modern',
    colors: {
      upColor: '#00C087',
      downColor: '#FF6B9D',
      wickUpColor: '#00C087',
      wickDownColor: '#FF6B9D',
      borderUpColor: '#00C087',
      borderDownColor: '#FF6B9D',
      volumeUpColor: '#00C087',
      volumeDownColor: '#FF6B9D',
      longLineColor: '#00C087',
      shortLineColor: '#FF6B9D',
    },
  },
  {
    id: 'neon',
    name: 'Neon',
    colors: {
      upColor: '#00D9FF',
      downColor: '#FF00E5',
      wickUpColor: '#00D9FF',
      wickDownColor: '#FF00E5',
      borderUpColor: '#00D9FF',
      borderDownColor: '#FF00E5',
      volumeUpColor: '#00D9FF',
      volumeDownColor: '#FF00E5',
      longLineColor: '#00D9FF',
      shortLineColor: '#FF00E5',
    },
  },
  {
    id: 'contrast',
    name: 'High Contrast',
    colors: {
      upColor: '#FFD700',
      downColor: '#9400D3',
      wickUpColor: '#FFD700',
      wickDownColor: '#9400D3',
      borderUpColor: '#FFD700',
      borderDownColor: '#9400D3',
      volumeUpColor: '#FFD700',
      volumeDownColor: '#9400D3',
      longLineColor: '#FFD700',
      shortLineColor: '#9400D3',
    },
  },
  {
    id: 'inverted',
    name: 'Inverted',
    colors: {
      upColor: '#F71053',
      downColor: '#37A16A',
      wickUpColor: '#F71053',
      wickDownColor: '#37A16A',
      borderUpColor: '#F71053',
      borderDownColor: '#37A16A',
      volumeUpColor: '#F71053',
      volumeDownColor: '#37A16A',
      longLineColor: '#F71053',
      shortLineColor: '#37A16A',
    },
  },
];

export const DEFAULT_CHART_THEME = 'classic';
